import React, { useState, useEffect } from 'react'
import {
  SMALL_DESKTOP,
  LARGE_DESKTOP,
  MEDIUM_DESKTOP,
  MAX_QUESTION_HEIGHT,
  MIN_QUESTION_HEIGHT
} from '../constants'
import JqxKnob, {
  IKnobProps
} from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxknob'
import 'katex/dist/katex.min.css'
import { InlineMath } from 'react-katex'
import PropTypes from 'prop-types'

function RotateDynamicComponent(props) {
  const {
    mcData,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd
  } = props
  const {
    ControlID,
    QuestionText,
    QuestionType,
    Answers,
    MinValue,
    MaxValue,
    Type,
    MinRange,
    MaxRange,
    Score,
    Background,
    Description,
    StepCount,
    QuestionColorFill,
    QuestionFontSize,
    Opacity,
    QuestionFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    AnswerColorFill,
    AnswerFillColor
  } = mcData

  const [value, setValue] = useState(MinValue)
  const [incrementFactorArray, setIncrementFactorArray] = useState([])
  const [stepArray, setStepArray] = useState([])
  const [screenChanged, setScreenChanged] = useState('')

  useEffect(() => {
    if (defaultValue) {
      let defaultValueSelected = defaultValue.CtlValue.value
      setValue(defaultValueSelected)
    } else {
      setValue(MinValue)
    }
    setScreenChanged(new Date())
    //Rotate values
    let stepArrayCopy = [...stepArray]
    for (let index = MinValue; index <= MaxValue; index = index + StepCount) {
      if (index % StepCount === 0) {
        stepArrayCopy.push(index)
      }
    }
    setStepArray(stepArrayCopy)
  }, [defaultValue])

  useEffect(() => {
    //Label text
    let stepCountString = StepCount.toString().split('.')[1]
    let toFixed = false
    if (stepCountString) {
      toFixed = true
    }

    const incrementFactor = (MaxValue - MinValue) / 4
    let incrementFactorArrayCopy = [...incrementFactorArray]
    for (let index = 0; index < 4; index++) {
      if (toFixed) {
        incrementFactorArrayCopy.push(MinValue + incrementFactor * index)
      } else {
        incrementFactorArrayCopy.push(
          Math.round(MinValue + incrementFactor * index)
        )
      }
    }
    setIncrementFactorArray(incrementFactorArrayCopy)
  }, [])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, value)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick) {
      if (Type === 'exactMatch') {
        if (value === Answers) {
          onExplanationVisible(true, CorrectAnswerExplanation)
        } else {
          onExplanationVisible(false, IncorrectAnswerExplanation)
        }
      } else if (Type === 'range') {
        if (value >= MinRange && value <= MaxRange) {
          onExplanationVisible(true, CorrectAnswerExplanation)
        } else {
          onExplanationVisible(false, IncorrectAnswerExplanation)
        }
      }
    }
  }, [explanationClick])

  function handleOptionChange(event) {
    setValue(event.args.value)
    document.body.onmouseup = (even) => {
      if (even.target.nodeName === 'circle') {
        onAttemptChange(1)
        validateCorrectAnswer(false, event.args.value)
        if (Type === 'exactMatch') {
          if (event.args.value === Answers) {
            handleSuccessChange(true)
          } else {
            handleSuccessChange(false)
          }
        } else if (Type === 'range') {
          if (event.args.value >= MinRange && event.args.value <= MaxRange) {
            handleSuccessChange(true)
          } else {
            handleSuccessChange(false)
          }
        }
      }
    }
  }

  function validateCorrectAnswer(timerValue, value) {
    const difference = MaxValue - MinValue
    let x = (value * 360) / difference
    if (x < 0) {
      x = Math.abs(180 + x)
    }
    const savedValues = { value: value, rotateValue: x }
    if (Type === 'exactMatch') {
      if (value === Answers) {
        onValueChange(ControlID, savedValues, Score, Score, '', timerValue)
      } else {
        onValueChange(ControlID, savedValues, 0, Score, '', timerValue)
      }
    } else if (Type === 'range') {
      if (value >= MinRange && value <= MaxRange) {
        onValueChange(ControlID, savedValues, Score, Score, '', timerValue)
      } else {
        onValueChange(ControlID, savedValues, 0, Score, '', timerValue)
      }
    }
  }

  const styles = {
    fill: {
      color: AnswerFillColor,
      gradientStops: [
        [0, 1],
        [50, 0.9],
        [100, 1]
      ],
      gradientType: 'linear'
    },
    stroke: '#dfe3e9',
    strokeWidth: 1
  }
  const pointer = {
    offset: '55%',
    size: '8%',
    style: { fill: SelectionColor, stroke: 'grey' },
    thickness: 20,
    type: 'circle'
  }
  const progressBar = {
    background: { fill: 'grey', stroke: 'grey' },
    offset: '50%',
    size: '9%',
    style: { fill: SelectionColor, stroke: 'grey' }
  }
  const marks = {
    colorProgress: '#333',
    colorRemaining: '#333',
    majorInterval: Math.round((MaxValue - MinValue) / 10),
    majorSize: '10%',
    //minorInterval: Math.round((MaxValue - MinValue) / 10),
    offset: '60%',
    size: '6%',
    thickness: 1,
    type: 'line'
  }
  const labels = {
    formatFunction: (label) => {
      if (incrementFactorArray && incrementFactorArray.length > 0) {
        let inv = 1.0 / StepCount
        let roudValue1 = Math.round(incrementFactorArray[1] * inv) / inv
        let roudValue2 = Math.round(incrementFactorArray[2] * inv) / inv
        let roudValue3 = Math.round(incrementFactorArray[3] * inv) / inv
        switch (label) {
          case incrementFactorArray[0].toString():
            return MaxValue + ' / ' + MinValue
          case roudValue1.toString():
            return roudValue1
          case roudValue2.toString():
            return roudValue2
          case roudValue3.toString():
            return roudValue3
          default:
            return ''
        }
      }
    },
    offset: '80%',
    step: StepCount,
    color: AnswerColorFill
  }

  return (
    <div className='slide-comp-wrapper'>
      <div
        style={{
          flex: 8,
          display: 'flex',
          justifyContent: 'center',
          pointerEvents: completed === 1 || !isActive ? 'none' : 'auto'
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <JqxKnob
            key={screenChanged}
            width={'350px'}
            height={'350px'}
            value={value && value}
            onChange={handleOptionChange}
            min={MinValue}
            max={MaxValue}
            step={StepCount}
            startAngle={270}
            endAngle={630}
            snapToStep={true}
            rotation={'clockwise'}
            styles={styles}
            pointer={pointer}
            progressBar={progressBar}
            marks={marks}
            labels={labels}
            style={{ alignSelf: 'center' }}
          />
          <p
            style={{
              position: 'absolute',
              fontSize: '30px',
              color: SelectionColor,
              alignSelf: 'center',
              margin: 'auto'
            }}
          >
            {value}
          </p>
        </div>
      </div>
      <div style={{ flex: 2, display: 'flex', justifyContent: 'center' }}>
        {isVerifyMode && (
          <p
            style={{
              textAlign: 'center',
              fontSize: LARGE_DESKTOP,
              color: QuestionColorFill
            }}
          >
            {Type === 'range'
              ? 'The correct answer is "' + MinRange + ' - ' + MaxRange + '"'
              : 'The correct answer is "' + Answers + '"'}
          </p>
        )}
      </div>
    </div>
  )

  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundColor: Background !== '' ? Background : '#dc8c82',
        justifyContent: 'center',
        borderRadius: '10px'
      }}
    >
      <div
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: Opacity,
          padding: '15px'
        }}
      >
        {QuestionText !== '' &&
          (QuestionType && QuestionType === 'text' ? (
            <div
              className='scrollBox card-shadow'
              style={{
                minHeight: MIN_QUESTION_HEIGHT,
                maxHeight: MAX_QUESTION_HEIGHT,
                width: '100%',
                backgroundColor: QuestionFillColor,
                borderRadius: '10px',
                padding: '1%'
              }}
            >
              <p
                style={{
                  width: 'fit-content',
                  justifyContent: 'center',
                  color: QuestionColorFill,
                  fontSize:
                    QuestionFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : QuestionFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  whiteSpace: 'pre-wrap',
                  margin: 0
                }}
              >
                {QuestionText}
              </p>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                margin: '2%',
                minHeight: MIN_QUESTION_HEIGHT,
                maxHeight: MAX_QUESTION_HEIGHT,
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <div
                className='card-shadow'
                style={{
                  width: 'fit-content',
                  justifyContent: 'center',
                  backgroundColor:
                    QuestionType === 'inktotext' ? QuestionFillColor : 'white',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  height: '100%',
                  maxHeight: '100px',
                  minWidth: '10%',
                  padding: '1%',
                  fontSize:
                    QuestionFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : QuestionFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  color: QuestionColorFill
                }}
              >
                {QuestionType === 'inktotext' ? (
                  <span
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <InlineMath>{QuestionText}</InlineMath>
                  </span>
                ) : (
                  <img
                    src={QuestionText}
                    style={{
                      width: '70px',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                    alt='image'
                  />
                )}
              </div>
              {Description !== '' && (
                <div
                  className='scrollBox card-shadow'
                  style={{
                    width: '100%',
                    height: '100%',
                    marginLeft: '1%',
                    marginRight: '1%',
                    display: 'flex',
                    backgroundColor: QuestionFillColor,
                    borderRadius: '10px',
                    padding: '1%'
                  }}
                >
                  <p
                    style={{
                      width: 'fit-content',
                      justifyContent: 'center',
                      alignItems: 'flex-end',
                      color: QuestionColorFill,
                      fontSize:
                        QuestionFontSize === 'SMALL'
                          ? SMALL_DESKTOP
                          : QuestionFontSize === 'LARGE'
                          ? LARGE_DESKTOP
                          : MEDIUM_DESKTOP,
                      margin: 0,
                      whiteSpace: 'pre-wrap'
                    }}
                  >
                    {Description}
                  </p>
                </div>
              )}
            </div>
          ))}
        <div
          style={{
            flex: 7,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              flex: 8,
              display: 'flex',
              justifyContent: 'center',
              pointerEvents: completed === 1 || !isActive ? 'none' : 'auto'
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <JqxKnob
                key={screenChanged}
                width={'350px'}
                height={'350px'}
                value={value && value}
                onChange={handleOptionChange}
                min={MinValue}
                max={MaxValue}
                step={StepCount}
                startAngle={270}
                endAngle={630}
                snapToStep={true}
                rotation={'clockwise'}
                styles={styles}
                pointer={pointer}
                progressBar={progressBar}
                marks={marks}
                labels={labels}
                style={{ alignSelf: 'center' }}
              />
              <p
                style={{
                  position: 'absolute',
                  fontSize: '30px',
                  color: SelectionColor,
                  alignSelf: 'center',
                  margin: 'auto'
                }}
              >
                {value}
              </p>
            </div>
          </div>
          <div style={{ flex: 2, display: 'flex', justifyContent: 'center' }}>
            {isVerifyMode && (
              <p
                style={{
                  textAlign: 'center',
                  fontSize: LARGE_DESKTOP,
                  color: QuestionColorFill
                }}
              >
                {Type === 'range'
                  ? 'The correct answer is "' +
                    MinRange +
                    ' - ' +
                    MaxRange +
                    '"'
                  : 'The correct answer is "' + Answers + '"'}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

RotateDynamicComponent.propTypes = {
  mcData: PropTypes.object.isRequired,
  completed: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  onValueChange: PropTypes.func.isRequired,
  onAttemptChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.object.isRequired,
  explanationClick: PropTypes.bool.isRequired,
  onExplanationVisible: PropTypes.func.isRequired,
  isVerifyMode: PropTypes.bool,
  handleSuccessChange: PropTypes.func,
  timerEnd: PropTypes.bool
}

export default RotateDynamicComponent
